import classNames from "classnames";
import PropTypes from "prop-types";
import CanvasIcon from "./CanvasIcon";
import ScreenThumbnail from "./ScreenThumbnail";
import { PREVIEW_WIDTH, WORKSHOP_ICONS } from "./workshop-view";

export const CARD_TONES = {
  DEFAULT: "default",
  STATE: "state",
  BEFORE: "before",
  AFTER: "after",
};

const WorkshopScreenCard = ({
  html,
  styleContent,
  caption,
  count,
  tone,
  spacious,
  highlightSlot,
  numbered,
  flaggedSlots,
  outlineAll,
  onSlotSelect,
  onHighlight,
  zones,
  sample,
  tools,
}) => (
  <div
    className={classNames("workshop-screen", {
      "workshop-screen--spacious": spacious,
    })}
  >
    <div className="workshop-screen__card">
      <div
        className={classNames("workshop-screen__caption", {
          "workshop-screen__caption--tools": Boolean(tools),
        })}
      >
        <span
          className={`workshop-screen__dot workshop-screen__dot--${tone}`}
        />
        <span className="workshop-screen__name">{caption}</span>
        {count ? <span>{count}</span> : null}
        {sample ? (
          <button
            type="button"
            className={classNames("workshop-screen__sample", {
              "workshop-screen__sample--on": sample.on,
            })}
            aria-pressed={sample.on}
            title={sample.title}
            disabled={sample.busy}
            onClick={sample.onToggle}
          >
            <CanvasIcon
              path={sample.busy ? WORKSHOP_ICONS.busy : WORKSHOP_ICONS.eye}
              size={16}
              strokeWidth={1.9}
            />
            {sample.label}
          </button>
        ) : null}
        {tools}
      </div>
      <ScreenThumbnail
        html={html || ""}
        styleContent={styleContent}
        size="fit"
        title={caption}
        highlightSlot={highlightSlot}
        numbered={numbered}
        flaggedSlots={flaggedSlots}
        outlineAll={outlineAll}
        onSlotSelect={onSlotSelect}
        onHighlight={onHighlight}
        zones={zones}
        viewport={PREVIEW_WIDTH}
      />
    </div>
  </div>
);

WorkshopScreenCard.propTypes = {
  html: PropTypes.string,
  styleContent: PropTypes.string,
  caption: PropTypes.string.isRequired,
  count: PropTypes.string,
  tone: PropTypes.oneOf(Object.values(CARD_TONES)),
  spacious: PropTypes.bool,
  highlightSlot: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  numbered: PropTypes.bool,
  flaggedSlots: PropTypes.arrayOf(PropTypes.string),
  outlineAll: PropTypes.bool,
  onSlotSelect: PropTypes.func,
  onHighlight: PropTypes.func,
  zones: PropTypes.object,
  tools: PropTypes.node,
  sample: PropTypes.shape({
    on: PropTypes.bool,
    busy: PropTypes.bool,
    label: PropTypes.string,
    title: PropTypes.string,
    onToggle: PropTypes.func,
  }),
};

WorkshopScreenCard.defaultProps = {
  html: "",
  styleContent: undefined,
  count: "",
  tone: CARD_TONES.DEFAULT,
  spacious: false,
  highlightSlot: null,
  numbered: false,
  flaggedSlots: null,
  outlineAll: false,
  onSlotSelect: null,
  onHighlight: null,
  zones: null,
  sample: null,
  tools: null,
};

export default WorkshopScreenCard;
